import React, { useEffect } from 'react';
import { useStores } from "../helpers";

const DeviceChecker: React.FC = () => {
    const { UIStore } = useStores();

    useEffect(() => {
        const clientUA = navigator.userAgent;
        const screenWidth = window.innerWidth;
        const requestUrl = window.location.href;

        const clientDeviceType = UIStore.isDesktop ? 'desktop' : 'mobile';
        const serverDeviceType = window.APP_SETTINGS.device;

        // console.log('Detected device (client):', clientDeviceType);
        // console.log('Detected device (server):', serverDeviceType);

        if (clientDeviceType !== serverDeviceType) {
            const payload = {
                server_device_type: serverDeviceType,
                user_agent: clientUA,
                width: screenWidth,
                request_url: requestUrl,
            };

            fetch(`${window.API_HOST}/api/visit/device`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            }).catch(() => { });
        }
    }, []);

    return null;
};

export default DeviceChecker;
